import { render, staticRenderFns } from "./clientUser-add.vue?vue&type=template&id=10e2a7ea&scoped=true"
import script from "./clientUser-add.vue?vue&type=script&lang=js"
export * from "./clientUser-add.vue?vue&type=script&lang=js"
import style0 from "./clientUser-add.vue?vue&type=style&index=0&id=10e2a7ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2a7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e2a7ea')) {
      api.createRecord('10e2a7ea', component.options)
    } else {
      api.reload('10e2a7ea', component.options)
    }
    module.hot.accept("./clientUser-add.vue?vue&type=template&id=10e2a7ea&scoped=true", function () {
      api.rerender('10e2a7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/clientUser-add.vue"
export default component.exports